import { media } from "../../design/breakpoints";
import axios from "axios";
import React, { useContext, useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { GlobalState } from "../../GlobalState";
import { DashboardSvg } from "../../assets/svg";
import DashboardSensorBoxV2 from "../sensor/DashboadSensorBoxV2";
import PumpStatusV2 from "../sensor/PumpStatusV2";
import PumpStatusV3 from "../sensor/PumpStatusV3";
import SolenoidBoxComponent from "../sensor/SolenoidBox";
import Banner from "../utils/banner";
import GatewayBoxComponent from "../sensor/gatwayDashboard";
import { Link } from "react-router-dom";
import SplashScreen from "../utils/SplashScreen";
import { syncFcmToken, getDeviceToken } from "../utils/deviceToken";
import { useDashboardReady } from "../utils/dashboardReady";

/* ─── Layout shells ─────────────────────────────────────────────────────── */
const Container = styled.div`
  margin: auto;
  width: 90%;
  position: relative;
  margin-top: 0;
`;

const ContentContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, min(max-content, 100%));
  justify-content: center;
  row-gap: 0.3rem;
  width: 100%;
`;

const SensorType = styled.h3`
  color: #107066;
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.15rem 0.2rem;
  padding: 0;
  width: 100%;
  text-align: left;
`;

// const SensorWrapper = styled.div`
//   border-radius: 20px;
//   display: flex;
//   /* Both width declarations must be fit-content so the box shrinks to card width */
//   width: fit-content;
//   flex-wrap: wrap;
//   flex-direction: column;
//   justify-content: center;
//   padding: 0.2rem;
//   margin: 0.5rem auto;
//   gap: 0.5rem;
//   /* Removed max-width: 85% — was overriding fit-content on desktop */
// `;

const SensorWrapper = styled.div`
  border-radius: 20px;
  display: flex;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  padding: 0.2rem;
  margin: 0.5rem 0;
  gap: 0.5rem;
`;

// const OuterBox = styled.div`
//   /* Image 2: fit-content so box shrinks to card width, not full SensorWrapper width */
//   width: fit-content;
//   background: #fafafa;
//   border-radius: 14px;
//   padding: 0.4rem 0.3rem;
//   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
//   display: flex;
//   flex-wrap: wrap;
//   column-gap: 20px;
//   row-gap: 4px;
//   justify-content: center;
// `;

const OuterBox = styled.div`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  background: #fafafa;
  border-radius: 14px;
  padding: 0.4rem 0.3rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-wrap: wrap;
  column-gap: 20px;
  row-gap: 4px;
  justify-content: center;
`;

const ContainerWrapper = styled.div`
  margin-bottom: 0.3rem;
`;

const BannerTitle = styled.span`
  color: #107066;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  ${media.max480} {
    font-size: 0.85rem;
  }
`;

/* ── Summary strip ───────────────────────────────────────────────────────── */
const SummaryStrip = styled.div`
  display: flex;
  align-items: stretch;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  overflow: visible;           /* allow tooltip overflow */
  margin: 0.4rem auto 0.6rem;
  width: fit-content;
  max-width: 100%;
`;

const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 7px 18px;
  border-right: 1px solid #f3f4f6;
  &:last-child { border-right: none; }
  ${media.max480} { padding: 6px 12px; }
`;

const SummaryCount = styled.span`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ $color }) => $color || "#111827"};
  line-height: 1;
`;

const SummaryLabel = styled.span`
  font-size: 0.6rem;
  font-weight: 600;
  color: #4B5563;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-top: 2px;
  white-space: nowrap;
`;

/* ── Issue 4: Gateway section — supports multiple gateways ──────────────── */
const GatewaySection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-left: 1px solid #f3f4f6;
  ${media.max480} { padding: 6px 10px; }
`;

const GatewaySectionLabel = styled.span`
  font-size: 0.6rem;
  font-weight: 600;
  color: #4B5563;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-right: 4px;
  white-space: nowrap;
`;

/* Issue 5: Each gateway dot — tooltip on hover showing name when offline */
const GatewayDotWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;

  /* tooltip */
  &::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 6px);
    left: 50%;
    transform: translateX(-50%);
    background: #1f2937;
    color: #fff;
    font-size: 0.7rem;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 6px;
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
    z-index: 100;
  }
  /* arrow */
  &::before {
    content: "";
    position: absolute;
    bottom: calc(100% + 2px);
    left: 50%;
    transform: translateX(-50%);
    border: 4px solid transparent;
    border-top-color: #1f2937;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.15s ease;
    z-index: 100;
  }
  &:hover::after,
  &:hover::before {
    opacity: 1;
  }
`;

const GatewayDot = styled.div`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
  cursor: ${({ $isOnline }) => ($isOnline ? "default" : "help")};
  background: ${({ $isOnline }) => ($isOnline ? "#22C55E" : "#94A3B8")};
  box-shadow: ${({ $isOnline }) =>
    $isOnline ? "0 0 0 3px rgba(34,197,94,.2)" : "none"};
  transition: background 0.3s ease;
`;

/* ── Issue 1: DeviceGroup — shrinks to content, no forced breaks ─────────── */
const DeviceGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  /* Centre cards within the box (Image 1) */
  justify-content: center;
`;

/* Sub-labels only when counts are large enough to warrant grouping */
const SubLabel = styled.div`
  width: 100%;
  font-size: 0.62rem;
  font-weight: 700;
  color: #4B5563;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 4px 8px 2px;
`;

/* Issue 5: Offline tooltip on sensor cards is handled inside DashboadSensorBoxV2
   via the existing tooltip system. For the summary strip offline pill we use
   the GatewayDotWrapper approach above. */

/* ── Helpers ─────────────────────────────────────────────────────────────── */
function getPumpLabel(sensors) {
  const hasPump     = sensors.some((s) => s.motor_id && !s.isBorewell);
  const hasBorewell = sensors.some((s) => s.motor_id && s.isBorewell);
  if (hasPump && hasBorewell) return "Pump / Borewell";
  if (hasBorewell) return "Borewell";
  return "Pump";
}

/* Returns true if a group contains ONLY gateway sensors — skip rendering it */
function isGatewayOnlyGroup(sensors) {
  return sensors.every((s) => s?.type === "Gateway");
}

export default function DashboardV2() {
  const state = useContext(GlobalState);
  const { setReady } = useDashboardReady();
  const [loading,    setLoading]    = useState(true);
  const [sensorList, setSensorList] = useState([]);
  /* Live status map: id → isOnline */
  const [statusMap, setStatusMap] = useState({});

  /* Issue 4: track multiple gateways: array of { name, isOnline } */
  const [gatewayList, setGatewayList] = useState([]);

  const reportStatus = useCallback((id, isOnline) => {
    setStatusMap((prev) => {
      if (prev[id] === isOnline) return prev;
      return { ...prev, [id]: isOnline };
    });
  }, []);

  /* Issue 4: gateway reporter receives name + status */
  const reportGateway = useCallback((name, isOnline) => {
    setGatewayList((prev) => {
      const exists = prev.find((g) => g.name === name);
      if (exists && exists.isOnline === isOnline) return prev;
      if (exists) return prev.map((g) => g.name === name ? { ...g, isOnline } : g);
      return [...prev, { name, isOnline }];
    });
  }, []);

  const totalDevices = Object.keys(statusMap).length;
  const onlineCount  = Object.values(statusMap).filter(Boolean).length;
  const offlineCount = totalDevices - onlineCount;

    useEffect(() => {
    if (!loading) setReady(true);
  }, [loading, setReady]);

  useEffect(() => {
    return () => setReady(false);
  }, [setReady]);

  useEffect(() => {
    async function fetchData(token) {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API}/user/v2/sensor_list`,
          { headers: { Authorization: token[0] } }
        );

        const enriched = await Promise.all(
          res.data.map(async (item) => {
            const sensors = await Promise.all(
              item.sensors.map(async (sensor) => {
                if (sensor.motor_id && sensor.isBorewell) {
                  try {
                    const r = await axios.get(
                      `${process.env.REACT_APP_API}/sensor/reading?sensor_id=${sensor.sensor_id}&type=water-sense`,
                      { headers: { Authorization: token[0] } }
                    );
                    if (r.data && r.data.name === "water-sense")
                      return { ...sensor, isHydrosense: true };
                  } catch (_) {}
                }
                return { ...sensor, isHydrosense: false };
              })
            );
            return { ...item, sensors };
          })
        );

        setSensorList(enriched);

        // Register solenoid/valve devices in statusMap
        // Type check is case-insensitive to handle API variations
        // Uses sensor_online or sensor_status field from the list,
        // with a live solenoid API call as a fallback for accurate status
        const solenoidSensors = enriched.flatMap(item =>
          (item.sensors || []).filter(s =>
            s?.type?.toLowerCase().includes("solenoid") && s?.solenoid_id
          )
        );
        
        // Register immediately with whatever status we have from the sensor list
        solenoidSensors.forEach(sensor => {
          const knownOnline =
            sensor?.sensor_online === true ||
            sensor?.sensor_online === 1 ||
            sensor?.sensor_status === "online";
          setStatusMap(prev => ({
            ...prev,
            [`sol-${sensor.solenoid_id}`]: knownOnline
          }));
        });

        // Then refresh with live data from solenoid endpoint
        if (solenoidSensors.length > 0) {
          solenoidSensors.forEach(async sensor => {
            try {
              const r = await axios.get(
                `${process.env.REACT_APP_API}/sensor/solenoid?solenoid_id=${sensor.solenoid_id}`,
                { headers: { Authorization: token[0] } }
              );
              const isOnline =
                r.data?.data?.sensor_online === true ||
                r.data?.data?.sensor_online === 1 ||
                r.data?.data?.sensor_online === "true" ||
                r.data?.data?.sensor_status === "online";
              setStatusMap(prev => ({
                ...prev,
                [`sol-${sensor.solenoid_id}`]: isOnline
              }));
            } catch { /* keep the initial registration */ }
          });
        }

        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    }

    fetchData(state.token);

    (async () => {
      try {
        const fcmToken = await syncFcmToken();
        const deviceId = getDeviceToken();
        if (fcmToken && deviceId) {
          await axios.put(
            `${process.env.REACT_APP_API}/user/update_device_data`,
            { deviceId, fcmToken },
            { headers: { Authorization: state.token[0] } }
          );
        }
      } catch (_) {}
    })();
  }, [state.token]);

  // if (loading) return <SplashScreen />;
   if (loading) return null;

  return (
    <Container>
      <Link to="/profile">
        <Banner
          title={<BannerTitle>Welcome {state.userAPI.name}</BannerTitle>}
          subtitle=""
          tooltip="View Your Profile"
        >
          <DashboardSvg />
        </Banner>
      </Link>

      {/* Summary strip */}
      <SummaryStrip>
        <SummaryItem>
          <SummaryCount $color="#111827">{totalDevices || "—"}</SummaryCount>
          <SummaryLabel>Devices</SummaryLabel>
        </SummaryItem>
        <SummaryItem>
          <SummaryCount $color="#16A34A">{onlineCount}</SummaryCount>
          <SummaryLabel>Online</SummaryLabel>
        </SummaryItem>
        {offlineCount > 0 && (
          <SummaryItem>
            <SummaryCount $color="#9CA3AF">{offlineCount}</SummaryCount>
            <SummaryLabel>Offline</SummaryLabel>
          </SummaryItem>
        )}

        {/* Issue 4 + 5: one dot per gateway, tooltip on offline ones */}
        {gatewayList.length > 0 && (
          <GatewaySection>
            <GatewaySectionLabel>Gateway</GatewaySectionLabel>
            {gatewayList.map((gw, i) => (
              <GatewayDotWrapper
                key={i}
                /* Issue 5: tooltip shows name only when offline */
                data-tooltip={!gw.isOnline ? `${gw.name} — offline` : undefined}
              >
                <GatewayDot $isOnline={gw.isOnline} />
              </GatewayDotWrapper>
            ))}
          </GatewaySection>
        )}
      </SummaryStrip>

      <ContentContainer>
        {sensorList.map((items, idx) => {
          if (!items.sensors || items.sensors.length === 0) return null;

          /* Issue 3 (gateway ghost): skip groups that are gateways only */
          if (isGatewayOnlyGroup(items.sensors)) {
            return items.sensors
              .filter((s) => s?.type === "Gateway")
              .map((sensor, i) => (
                /* Mount invisibly to report status; render nothing */
                <GatewayBoxComponent
                  key={`gw-hidden-${idx}-${i}`}
                  sensor={sensor}
                  onStatusReport={reportGateway}
                  hidden
                />
              ));
          }

          const pumps               = items.sensors.filter((s) => s?.motor_id && !s.isBorewell);
          const regularBorewells    = items.sensors.filter((s) => s?.motor_id && s.isBorewell && !s.isHydrosense);
          const hydrosenseBorewells = items.sensors.filter((s) => s?.motor_id && s.isBorewell && s.isHydrosense);
          const allBorewells        = [...regularBorewells, ...hydrosenseBorewells];

          /* Issue 1: only show sub-labels when BOTH groups have 2+ devices
             (1 pump + 1 borewell → no labels, they sit side by side cleanly) */
          const showSubLabels =
            pumps.length > 0 &&
            allBorewells.length > 0 &&
            (pumps.length > 1 || allBorewells.length > 1);

          return (
            <ContainerWrapper key={`container-${idx}`}>
              <SensorWrapper>
                <OuterBox>
                  <SensorType>
                    {items.label === "Pump"
                      ? getPumpLabel(items.sensors)
                      : items.label?.replace(/Solenoid Valves?/i, "Valves")}
                  </SensorType>

                  {/* Any gateways in a mixed group — still hidden */}
                  {items.sensors
                    .filter((s) => s?.type === "Gateway")
                    .map((sensor, i) => (
                      <GatewayBoxComponent
                        key={`gateway-${i}`}
                        sensor={sensor}
                        onStatusReport={reportGateway}
                        hidden
                      />
                    ))}

                  {/* Water Level + Solenoid */}
                  {items.sensors
                    .filter((s) => !s?.motor_id && s?.type !== "Gateway")
                    .map((sensor, i) => {
                      if (sensor?.type === "Solenoid Valve") {
                        // Register solenoid in statusMap at render time — most reliable approach
                        // Runs synchronously when the sensor list is rendered
                        if (sensor?.solenoid_id) {
                          const solOnline = sensor?.sensor_online === true || sensor?.sensor_online === 1;
                          setTimeout(() => reportStatus(`sol-${sensor.solenoid_id}`, solOnline), 0);
                        }
                        return (
                          <SolenoidBoxComponent key={`sol-${i}`} sensor={sensor} />
                        );
                      }
                      return (
                        <DashboardSensorBoxV2
                          key={`s-${i}`}
                          sensor_id={sensor.sensor_id}
                          type={sensor.type}
                          onStatusReport={reportStatus}
                        />
                      );
                    })}

                  {/* Issue 1: Pumps — no sub-label for single pump */}
                  {pumps.length > 0 && (
                    <>
                      {showSubLabels && <SubLabel>Pumps</SubLabel>}
                      <DeviceGroup>
                        {pumps.map((sensor, i) => (
                          <PumpStatusV2
                            key={`p2-${i}`}
                            motor_id={sensor.motor_id}
                            sensor_id={sensor.sensor_id}
                            isBorewell={sensor.isBorewell}
                            onStatusReport={reportStatus}
                          />
                        ))}
                      </DeviceGroup>
                    </>
                  )}

                  {/* Issue 1: Borewells — no sub-label for single borewell */}
                  {allBorewells.length > 0 && (
                    <>
                      {showSubLabels && <SubLabel>Borewells</SubLabel>}
                      <DeviceGroup>
                        {allBorewells.map((sensor, i) => (
                          <PumpStatusV3
                            key={`p3-${i}`}
                            motor_id={sensor.motor_id}
                            sensor_id={sensor.sensor_id}
                            isBorewell={sensor.isBorewell}
                            onStatusReport={reportStatus}
                          />
                        ))}
                      </DeviceGroup>
                    </>
                  )}
                </OuterBox>
              </SensorWrapper>
            </ContainerWrapper>
          );
        })}
      </ContentContainer>
    </Container>
  );
}
